module.exports = angular.module('add-to-list-form', [
    require('../../../controllers/triggerPanel/addToListFormCtrl').name
])
    .directive('addToListForm', function () {
        return {
            restrict: 'E',
            scope: false,
            templateUrl: 'app/views/triggerPanel/add-to-list-form.tpl.html',
            controller: 'addToListFormCtrl',
        };
    });



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/triggerPanel/add-to-list-form.js